import { useEffect } from "react";

const DEFAULT_TITLE = "RAF Direct · Acolhimento Inteligente · Direcionamento Seguro";
const SITE_SUFFIX = "RAF Direct";

/**
 * Define <title> e <meta name="description"> por rota.
 * Ajuda no SEO — Google exibe o título específico da página no resultado
 * de busca em vez do título global do index.html.
 */
export const usePageTitle = (title, description) => {
  useEffect(() => {
    const prev = document.title;
    const finalTitle = title ? `${title} · ${SITE_SUFFIX}` : DEFAULT_TITLE;
    document.title = finalTitle;

    let metaEl = null;
    let prevDescription = null;
    if (description) {
      metaEl = document.querySelector('meta[name="description"]');
      if (metaEl) {
        prevDescription = metaEl.getAttribute("content");
        metaEl.setAttribute("content", description);
      }
    }

    return () => {
      document.title = prev;
      if (metaEl && prevDescription !== null) {
        metaEl.setAttribute("content", prevDescription);
      }
    };
  }, [title, description]);
};

export default usePageTitle;
